import { BrandPricesFilter } from "../../filters.js"

export function filterBrand() {


    BrandPricesFilter();
}

